import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../../services/login.service';
import { UsuarioService } from '../../../../services/usuario.service';

import { environment } from '../../../../../environments/environment'
import Swal from 'sweetalert2';


@Component({
	selector: 'app-aside',
	templateUrl: './aside.component.html',
	styleUrls: ['./aside.component.css']
})
export class AsideComponent implements OnInit {

	CLUBNAME:string = environment.CLUBNAME;

	usuario:any = {};
	cargandoUsuario:boolean = true;

	public isCollapsed = false;
	
	constructor( private loginService:LoginService, private usuarioService:UsuarioService) { }


	ngOnInit(): void {
		this.obtenerUsuario();
	}


	menu:any = {
		club: false,
		divisiones: false,
		noticias: false,
		anuncios: false,
		aficionados: false,
		ajustes: false,
		cuenta:false,
		reportes:false,
	}


	obtenerUsuario(){
		this.cargandoUsuario = true;
		this.usuarioService.getUsuarioActual().then( (res:any) => {
			// console.log(res);
			this.usuario = res;
			this.cargandoUsuario = false;
		}).catch( (err:any) => {
			this.cargandoUsuario = false;
			console.error(err);
		});
	}

	logout(){
		this.loginService.logout();
	}



	// logout(){


	// 	Swal.fire({title:'Procesando',allowOutsideClick: false});
	// 	Swal.showLoading();
	// 	this.usuarioService.cerrarSesion().then( res => {
	// 		Swal.close();

	// 		console.log(res);

	// 	})
	// 	.catch( err =>{
	// 		Swal.close();
	// 		console.error(err);
	// 	})
	// 	;
	// }


}
